import React from 'react';
import { Link } from 'react-router-dom';
import { APP_STORE_URL, PLAY_STORE_URL } from './constants';
import { IconApple, IconGooglePlayMark } from './HomeRedesignIcons';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';
import { ReactComponent as NavLogo } from './assets/nav-logo.svg';

const footerLink = 'font-jakarta text-[14.5px] text-[#2a0f2a] hover:text-chisme-primary';

const HomeRedesignFooter: React.FC = () => {
  const s = useHomeRedesignStrings();

  return (
    <footer className="border-t border-[rgba(74,33,71,0.1)] bg-[#fcf7fa] pt-12 pb-10">
      <div className="container-chisme flex flex-col gap-10 lg:flex-row lg:gap-8">
        <div className="flex max-w-sm flex-col gap-4">
          <Link to="/" className="relative block h-9 w-[120px] text-[#EB42B2]" aria-label={s.nav.logoAria}>
            <NavLogo aria-hidden className="absolute inset-0 size-full" />
          </Link>
          <p className="font-instrument text-xl italic leading-snug text-[#5a3158]">{s.footer.tagline}</p>
          <div className="flex flex-wrap gap-2.5 pt-1">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-[54px] items-center gap-2.5 rounded-[14px] border border-[rgba(42,15,42,0.12)] bg-white px-4 shadow-[0px_1px_0px_rgba(0,0,0,0.02)]"
            >
              <IconApple className="size-6 shrink-0 text-[#2a0f2a]" />
              <span className="flex flex-col items-start leading-tight text-[#2a0f2a]">
                <span className="text-[9.5px] font-medium opacity-75">{s.finalCta.downloadOn}</span>
                <span className="text-base font-bold tracking-[-0.01em]">{s.finalCta.appStore}</span>
              </span>
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-[54px] items-center gap-2.5 rounded-[14px] border border-[rgba(42,15,42,0.12)] bg-white px-4 shadow-[0px_1px_0px_rgba(0,0,0,0.02)]"
            >
              <IconGooglePlayMark className="size-6 shrink-0" />
              <span className="flex flex-col items-start leading-tight text-[#2a0f2a]">
                <span className="text-[9.5px] font-medium opacity-75">{s.finalCta.getItOn}</span>
                <span className="text-base font-bold tracking-[-0.01em]">{s.finalCta.googlePlay}</span>
              </span>
            </a>
          </div>
        </div>

        <div className="flex flex-1 flex-col gap-10 sm:flex-row sm:justify-start lg:justify-end lg:gap-16">
          <div>
            <p className="font-jetbrains text-[10.5px] uppercase tracking-[0.22em] text-[#5a3158]">
              {s.footer.product}
            </p>
            <ul className="mt-3.5 flex flex-col gap-2.5">
              <li>
                <Link to="/partners" className={`${footerLink} inline-flex items-center gap-2`}>
                  {s.footer.partners}
                  <span className="rounded-full bg-chisme-primary px-2 py-0.5 font-jetbrains text-[10px] font-bold uppercase tracking-[0.04em] text-white">
                    {s.footer.partnersNew}
                  </span>
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-jetbrains text-[10.5px] uppercase tracking-[0.22em] text-[#5a3158]">
              {s.footer.legal}
            </p>
            <ul className="mt-3.5 flex flex-col gap-2.5">
              <li>
                <Link to="/privacy" className={footerLink}>
                  {s.footer.privacy}
                </Link>
              </li>
              <li>
                <Link to="/terms" className={footerLink}>
                  {s.footer.terms}
                </Link>
              </li>
              <li>
                <Link to="/guidelines" className={footerLink}>
                  {s.footer.communityGuidelines}
                </Link>
              </li>
              <li>
                <Link to="/safety" className={footerLink}>
                  {s.footer.safety}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container-chisme mt-10 border-t border-[rgba(74,33,71,0.1)] pt-6">
        <div className="flex flex-col items-center gap-4 md:grid md:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] md:items-center">
          <div className="flex w-full justify-center md:col-start-3 md:row-start-1 md:w-auto md:justify-self-end">
            <LanguageSwitcher className="justify-center md:justify-end" />
          </div>
          <p className="w-full text-center font-jetbrains text-[11px] uppercase tracking-[0.12em] text-[#5a3158] md:col-start-2 md:row-start-1 md:px-2">
            {s.footer.madeWith}
          </p>
          <p className="w-full text-center font-jetbrains text-[11px] uppercase tracking-[0.12em] text-[#5a3158] md:col-start-1 md:row-start-1 md:min-w-0 md:text-left">
            {s.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default HomeRedesignFooter;
